webpackJsonp([55702396619907],{

/***/ 1830:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":2,"edges":[{"node":{"fields":{"slug":"/news/rla-awarded-marketing-week’s-masters-of-automotive-marketing-2018/"},"frontmatter":{"title":"RLA awarded Marketing Week’s Masters of Automotive Marketing 2018. ","templateKey":"news","thumb":{"responsive":{"childImageSharp":{"original":{"src":"/static/1160x450-marketing-awards-winner-article-header-image-v1-b228b0c32055862bd299d2a18ce8f730.jpg"}}},"original":"/img/1160x450-marketing-awards-winner-article-header-image-v1.jpg"},"category":"News"}}},{"node":{"fields":{"slug":"/news/the-role-of-emotion-in-automotive-purchasing/"},"frontmatter":{"title":"THE ROLE OF EMOTION IN AUTOMOTIVE PURCHASING AND WHAT THIS MEANS FOR CAR RETAILERS.","templateKey":"news","thumb":{"responsive":{"childImageSharp":{"original":{"src":"/static/1366x532-emotion-in-car-buying-8d9e31eb0f69038e4cc22a1524971abb.jpg"}}},"original":"/img/1366x532-emotion-in-car-buying.jpg"},"category":"News"}}}]}},"pathContext":{"tag":""}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-e82d7d5fa31f7b510ab4.js